import { render, staticRenderFns } from "./VaultListRoot.vue?vue&type=template&id=919fdb00&"
import script from "./VaultListRoot.vue?vue&type=script&lang=ts&"
export * from "./VaultListRoot.vue?vue&type=script&lang=ts&"
import style0 from "./VaultListRoot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports